import { SignupSection } from './SignupSection'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { authSlice } from '../../authSlice'
import { SignUpPassCode } from './SignUpPassCode'
import { PlatformRules } from './info/PlatformRules'
import { ReCaptcha } from './ReCaptcha'
import { Approval } from './Approval'
import { RegistrationClosed } from './RegistrationClosed'
import { Loader2 } from 'lucide-react'
import { MobileAuthHeader } from '../mobile/MobileAuthHeader'
import { useIsMobile } from '@wellesley/ui'
import { platformSettingsSlice } from '@wellesley/settings/slices/platformSettingsSlice'
import { useRedirectAfterAuth } from '../../hooks/useAuthRedirect'

const views = {
  rules: PlatformRules,
  signup: SignupSection,
  passCode: SignUpPassCode,
  captcha: ReCaptcha,
  approval: Approval,
}

export const SignupProcessSwitch: FC = () => {
  const step = useSelector(authSlice.selectors.selectSignupStep)

  const registrations = useSelector(
    platformSettingsSlice.selectors.selectRegistration,
  )

  if (!registrations) {
    return (
      <div className="flex h-[630px] items-center justify-center">
        <Loader2 className="h-10 w-10 animate-spin text-gray-500" />
      </div>
    )
  }

  if (registrations?.mode === 'CLOSED') {
    return <RegistrationClosed />
  }

  const View = views[step]
  return (
    <div className="flex h-[630px] flex-col overflow-hidden">
      <View />
    </div>
  )
}

const Mobile: FC = () => (
  <div className="mt-12 min-h-[calc(100vh-48px)] md:hidden">
    <MobileAuthHeader />
    <div className="h-full px-4">
      <SignupProcessSwitch />
    </div>
  </div>
)

export const Desktop: FC = () => {
  return (
    <div className="w-[600px] overflow-y-auto pt-xl">
      <SignupProcessSwitch />
    </div>
  )
}

export const SignupProcess: FC = () => {
  useRedirectAfterAuth()
  const isMobile = useIsMobile()

  return isMobile ? <Mobile /> : <Desktop />
}
